import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faArrowLeft,
  faArrowRight,
  faArrowUpRightFromSquare,
  faBuilding,
  faCheck,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faCircleCheck,
  faCircleInfo,
  faCircleXmark,
  faCopy,
  faCreditCard,
  faEdit,
  faExclamationTriangle,
  faEye,
  faEyeSlash,
  faHome,
  faInfo,
  faInfoCircle,
  faMinus,
  faPlus,
  faSortDown,
  faSortUp,
  faSpinner,
  faUsers,
  faXmark,
  // faHouse,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon, type FontAwesomeIconProps } from '@fortawesome/react-fontawesome';
import { twMerge } from 'tailwind-merge';

const icons = [
  faSpinner,
  faInfo,
  faInfoCircle,
  faXmark,
  faCheck,
  faCircleCheck,
  faMinus,
  faEdit,
  faCopy,
  faPlus,
  faCircleXmark,
  faChevronRight,
  faChevronLeft,
  faChevronDown,
  faChevronLeft,
  faCircleInfo,
  faArrowLeft,
  faArrowRight,
  faEye,
  faEyeSlash,
  faUsers,
  faHome,
  faCreditCard,
  faArrowUpRightFromSquare,
  faExclamationTriangle,
  faBuilding,
  faSortUp,
  faSortDown,
  // faHouse,
];

library.add(...icons);

export const Icon = ({ className, ...props }: FontAwesomeIconProps) => {
  return <FontAwesomeIcon height="1em" className={twMerge('w-[auto] flex-none', className)} {...props} />;
};
